import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { gamePercentAgent } from 'src/app/apis/agent.service';

@Component({
  selector: 'app-form-sports',
  templateUrl: './form-sports.component.html',
  styleUrls: ['./form-sports.component.scss']
})
export class FormSportsComponent implements OnInit {

  @Input() Data: any;
  @Output() DataChange = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  onChangePercent(game_code: string) {
    const game = this.Data.profit_sharing.find((c) => c.game_code === game_code) as gamePercentAgent;
    if (game.percent_own < 0) {
      game.percent_own = 0;
    }
    if (game.percent_own > game.percent_parent) {
      game.percent_own = game.percent_parent;
    }
    game.percent_given = game.percent_parent - game.percent_own;

    if (game.percent_given < 0) {
      game.percent_given = 0;
      game.percent_own = game.percent_parent;
    }

    this.DataChange.emit(this.Data);
  }

}
